

export default {
    name: "ReviewBox",
    props: {
        type: {
            type: Number,
            required: true,
            default: 0,
        },
        item: {
            type: Object,
            required: true,
            default: null,
        },
    },
    components: {

    },
    created() {

        let t = this;

        t.dict.status = listToDict(t.list.status);
    },
    activated() {
    },
    methods: {


        confirm(item) {

            let t = this;

            if (t.type == 1)
                A.safety(t.t('打刻申請を通すことを確認しますか？')).then(function (res) {
                    if (res.isConfirmed) {
                        axios.post('clockIn/confirmSup/' + item.id).then(res => {
                            if (res.data.status == 1) {
                                item.status = 1;
                                t.$emit('confirmed');
                            }
                        });
                    }
                });
            else if (t.type == 2)
                A.safety(t.t('この申請を承認してもよろしいですか？')).then(function (res) {
                    if (res.isConfirmed) {
                        axios.post('clockIn/confirmFieldWork/' + item.id).then(res => {
                            if (res.data.status == 1) {
                                item.status = 1;
                                t.$emit('confirmed');
                            }
                        });
                    }
                });
            else if (t.type == 3)
                A.safety(t.t('この申請を承認してもよろしいですか？')).then(function (res) {
                    if (res.isConfirmed) {
                        axios.post('clockIn/confirmShift/' + item.id).then(res => {
                            if (res.data.status == 1) {
                                item.status = 1;
                                t.$emit('confirmed');
                            }
                        });
                    }
                });
            else if (t.type == 5)
                A.safety(t.t('この申請を承認してもよろしいですか？')).then(function (res) {
                    if (res.isConfirmed) {
                        axios.post('clockIn/confirmLeave/' + item.id).then(res => {
                            if (res.data.status == 1) {
                                item.status = 1;
                                t.$emit('confirmed');
                            }
                        });
                    }
                });
        },

        reject(item) {

            let t = this;

            if (t.type == 1)
                A.safety(t.t('打刻申請を却下することを確認しますか？')).then(function (res) {
                    if (res.isConfirmed) {
                        axios.post('clockIn/rejectSup/' + item.id).then(res => {
                            if (res.data.status == 1) {
                                item.status = 2;
                                t.$emit('rejected');
                            }
                        });
                    }
                });
            else if (t.type == 2)
                A.safety(t.t('この申請を却下してもよろしいですか？')).then(function (res) {
                    if (res.isConfirmed) {
                        axios.post('clockIn/rejectFieldWork/' + item.id).then(res => {
                            if (res.data.status == 1) {
                                item.status = 2;
                                t.$emit('rejected');
                            }
                        });
                    }
                });
            else if (t.type == 3)
                A.safety(t.t('この申請を却下してもよろしいですか？')).then(function (res) {
                    if (res.isConfirmed) {
                        axios.post('clockIn/rejectShift/' + item.id).then(res => {
                            if (res.data.status == 1) {
                                item.status = 2;
                                t.$emit('rejected');
                            }
                        });
                    }
                });
            else if (t.type == 5)
                A.safety(t.t('この申請を却下してもよろしいですか？')).then(function (res) {
                    if (res.isConfirmed) {
                        axios.post('clockIn/rejectLeave/' + item.id).then(res => {
                            if (res.data.status == 1) {
                                item.status = 2;
                                t.$emit('rejected');
                            }
                        });
                    }
                });
        },


    },
    data() {
        return {
            list: {
                status: [
                    {
                        'id': -1,
                        'text': '全部'
                    },
                    {
                        'id': 0,
                        'text': '承認待ち'
                    },
                    {
                        'id': 1,
                        'text': '承認済'
                    },
                    {
                        'id': 2,
                        'text': '却下'
                    }
                ],
            },
            dict: {
                status: {}
            }

        };
    },
};
